const {linkModifiers} = require('../data/constants.json');
const {enlist, ensure} = require('../utils');

function createLinkModifier(slug, doNotShowFor, showEnglishFor) {
  return function (item, language) {
    if (!item.href || item.href.substr(item.href.indexOf(slug)) !== slug) {
      return item;
    }
    if (doNotShowFor.indexOf(language) >= 0) {
      return null;
    }
    const modifiedItem = Object.assign({}, item);
    if (showEnglishFor.indexOf(language) >= 0) {
      modifiedItem.href = modifiedItem.href.replace(`${language}.`, 'www.');
    }
    return modifiedItem;
  };
}

function classes(...classNames) {
  classNames = classNames.filter(className => className);
  return classNames.length ? `class="${classNames.join(' ')}"` : '';
}

function content(item, classNames) {
  const DEFAULT_TAG = 'span';

  if (item.href) {
    item.tag = 'a';
    item.contentAttrs = item.contentAttrs || {};
    item.contentAttrs.href = item.href;
  }

  item.tag = item.tag || DEFAULT_TAG;

  const attributes = Object.keys(item.contentAttrs || {})
                           .map(attribute => `${attribute}="${item.contentAttrs[attribute]}"`)
                           .join(' ');
  return `
    <${item.tag} ${attributes} ${classes(...enlist(classNames.itemContent, item.classes))}>
      ${item.text}
      ${ensure(item.extraContent) || ''}
    </${item.tag}>
  `;
}

function link(item, classNames, classNamesForSubs) {
  const attributes = Object.keys(item.attrs || {})
                           .map(attribute => `${attribute}="${item.attrs[attribute]}"`)
                           .join(' ');
  const hasSubs = item.subs && item.subs.length;
  return `
    <li ${attributes} ${classes(...enlist(classNames.item, item.classes, hasSubs ? classNames.hasSubmenu : null))}>
      ${content(item, classNames)}
      ${hasSubs ? links(item.subs, classNamesForSubs || classNames) : ''}
    </li>
  `;
}

function links(list = [], classNames = {}, classNamesForSubs = null) {
  const listClassNames = classNames.list instanceof Function ? classNames.list(list) : classNames.list;
  return `
    <ul ${classes(...enlist(listClassNames))}>
      ${list.map(item => link(item, classNames, classNamesForSubs)).join('')}
    </ul>
  `;
}

module.exports = {
  links,
  modifyBlogLink: createLinkModifier('/blog', linkModifiers.blog.hideForLanguages, linkModifiers.blog.showEnglishForLanguages),
  modifyStoriesLink: createLinkModifier('/stories', linkModifiers.stories.hideForLanguages, linkModifiers.stories.showEnglishForLanguages)
};



// WEBPACK FOOTER //
// ./templates/common.js